import React from "react";
import { useTranslation } from "react-i18next";
import SortableLabel from "../SortableLabel";
import styles from "../styles.module.scss";

const ReportHeader = ({ columns, sortBy, order, setSort }) => {
  const { t } = useTranslation();
  if (!columns || columns.length === 0) {
    return null;
  }

  const sortable = (name, field) => (
    <SortableLabel
      label={name}
      field={field}
      className={styles.sortable_container}
      sortBy={sortBy}
      order={order}
      setSort={setSort}
    />
  );

  return (
    <thead className={styles.table_header}>
      <tr className={styles.row}>
        {columns.map((column) => (
          <th key={column.field_name}>
            {column.sortable
              ? sortable(t(column.title), t(column.fieldName))
              : t(column.title)}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default ReportHeader;
